import type { WorkflowEnumItem } from "../hooks/useWorkflowEnums";

export const NOTIFY_USER_MESSAGE_FALLBACK =
    "You have received a new notification. Please check your account for details.";

const NOTIFY_USER_ACTION_CODE = "Action.Notify.NotifyUser";

function readMessageFromMeta(meta: WorkflowEnumItem["meta"] | undefined): string | null {
    if (!meta || typeof meta !== "object") return null;
    const top = (meta as { message?: unknown }).message;
    if (typeof top === "string" && top.trim()) return top.trim();
    const cfg = meta.config;
    if (cfg && typeof cfg === "object" && "message" in cfg) {
        const fromConfig = (cfg as { message?: unknown }).message;
        if (typeof fromConfig === "string" && fromConfig.trim()) return fromConfig.trim();
    }
    return null;
}

/** Display-only copy from workflows/enums for Action.Notify.NotifyUser (not persisted on the action node). */
export function getNotifyUserStaticMessageFromActionTypes(actionTypes: WorkflowEnumItem[]): string {
    const item = actionTypes.find((a) => a.code === NOTIFY_USER_ACTION_CODE);
    return readMessageFromMeta(item?.meta) ?? NOTIFY_USER_MESSAGE_FALLBACK;
}
